
export const hlzTeamTxt = [
  {
    id: 1,
    image: require('../images/ComponentImg/Team/Team-mmChen.jpg'),
    alt: 'images/ComponentImg/Team/Team-mmChen.jpg',
    // fbLink: 'https://www.facebook.com',
    // twitterLink: 'https://www.twitter.com',
    // linkedinLink: 'https://www.linkedin.com',
    employname: '陈明明',
    designation: '执行长',
    // designation: 'CEO',
    duties: '负责公司的战略计划，运营管理及业务发展，确保实现财务目标、生成效率和可持续发展目标',
  },
  {
    id: 2,
    image: require('../images/ComponentImg/Team/Team-syYao.jpg'),
    alt: 'images/ComponentImg/Team/Team-syYao.jpg',
    employname: '姚圣银',
    designation: '业务总监',
    duties: '全面负责公司的生产运营、业务规划、成本控制及团队管理，确保生产目标的高效达成',
  },
  {
    id: 3,
    image: require('../images/ComponentImg/Team/Team-sLi.jpg'),
    alt: 'images/ComponentImg/Team/Team-sLi.jpg',
    employname: '李帅',
    designation: '品质主管',
    duties: '监督和管理工厂生产全流程的质量控制工作。主导质量体系的优化与执行，协调跨部门合作；推动持续改进，降低质量风险，提升客户满意度',
  },
  {
    id: 4,
    image: require('../images/ComponentImg/Team/Team-qsHuang.jpg'),
    alt: 'images/ComponentImg/Team/Team-qsHuang.jpg',
    // alt: 'images/ComponentImg/Team-黄青松.jpg',
    employname: '黄青松',
    designation: '品质工程师',
    duties: '剖析生产与市场反馈的质量问题，制定改进方案；搭建质量标准体系，监控生产流程，及时优化工艺参数；同时协同各部门解决质量难题',
  },
  {
    id: 5,
    image: require('../images/ComponentImg/Team/Team-qPan.jpg'),
    alt: 'images/ComponentImg/Team/Team-qPan.jpg',
    // alt: 'images/ComponentImg/Team-潘琴.jpg',
    employname: '潘琴',
    designation: '研发工程师',
    duties: '负责统筹功能片产品全流程研发工作，涵盖技术方案制定、跨部门协作推进及产品质量与成本优化等，确保功能片高效开发并满足市场需求',
  },
  {
    id: 6,
    image: require('../images/ComponentImg/Team/Team-pZhang.jpg'),
    alt: 'images/ComponentImg/Team-pZhang.jpg',
    // alt: 'images/ComponentImg/Team-张鹏.jpg',
    // fbLink: 'https://www.facebook.com',
    // twitterLink: 'https://www.twitter.com',
    // linkedinLink: 'https://www.linkedin.com',
    employname: '张鹏',
    designation: '生产主管',
    duties: '根据公司目标制定生产计划，确保按时，按货、按量完成生产任务。合理调配人和设备，调整生产布局和提高生产效率',
  },

  // {
  //   id: 7,
  //   image: require('../images/ComponentImg/Team/Team-jzFu.jpg'),
  //   alt: 'images/ComponentImg/Team-付监忠.jpg',
  //   employname: '付监忠',
  //   designation: '工程主管',
  //   duties: '负责统筹工厂设备、设施及工程项目的规划、维护与优化确保生产设备高效稳定运行。并制定长期维护策略以保障生产的连续性',
  // },

  // {
  //   id: 8,
  //   image: require('../images/ComponentImg/team8.jpg'),
  //   alt: 'images/ComponentImg/team8.jpg',
  //   fbLink: 'https://www.facebook.com',
  //   twitterLink: 'https://www.twitter.com',
  //   linkedinLink: 'https://www.linkedin.com',
  //   employname: 'David Smith',
  //   designation: 'SEO Expert',
  //   duties: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui facilis, totam maiores.'
  // }
]
